import client from '../../utils/api'
import { createApiAction } from '../../utils/redux-tool'

export const generate = createApiAction(
  'scheduling/report-card/generate',
  client.save('/api/scheduling/report/report-card'),
)
